import { Button, ButtonGroup, ModalBody, ModalFooter, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Modal } from "components";
import { API } from "config";
import { useEffect, useState } from "react";

export default function UpdateOption({ optionKey, ...props }){

    const queryClient = useQueryClient()
    const toast = useToast()
    const [ optionData, setOptionData ] = useState()
    const [ option, setOption ] = useState()
    const [ loading, setLoading ] = useState(false)

    async function fetchData(optionKey) {
        try {
            setLoading(true)
            const response = await API.get(`/options/${optionKey}`)
            setOptionData(response?.data)
            setOption(response?.data?.value)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        try {
            fetchData(optionKey)
        } catch (error) {
        }
    }, [optionKey])

    const handleSubmit = async () => {
        setLoading(true)

        try {
            await API.put(`/options/${optionKey}`, {value: option})
            toast({ title: 'Opção alterada com sucesso.', status: 'success' })

            queryClient.invalidateQueries(['options'])
            props.onClose()
        } catch (error) {
            toast({ title: 'Não foi possível alterar a opção.', description: error?.response?.data?.message, status: 'warning' })
        } finally {
            setLoading(false)
        }
    }

    return(
    <Modal title="Editar Opção" closeOnOverlayClick={!loading} {...props}>
        <ModalBody>
            <Form.Form>
                <Form.Text
                    required
                    label="Nome da Opção:"
                    placeholder="Nome"
                    value={optionData?.key}
                    isDisabled
                />
                <Form.Text
                    required
                    label="Valor da Opção:"
                    placeholder="Valor"
                    value={option}
                    defaultValue={optionData?.value}
                    onChange={e => setOption(e.target.value)}
                    isDisabled={loading}
                />
            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" justifyContent="end">
                <Button colorScheme="orange" isLoading={loading} type="submit" onClick={handleSubmit} children="Editar" />
                <Button colorScheme="blue" isLoading={loading} type="button" onClick={props.onClose} children="Cancelar" />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}
